import styled from "styled-components";
import { Button } from "antd";

export const StyledExcelButton = styled(Button)`
    width: 40px;
    height: 40px;
    margin-left: 10px;
    color: white;

    &&,
    &&:focus {
        background-color: #227346;
        color: white;
    }

    &&:not(:disabled):hover,
    &&:not(:disabled):active {
        background-color: #1a5c37 !important;
        color: white !important;
    }

    &&:disabled {
        opacity: 0.6;
    }
`;
